<template>
	<div id="app">

		<div v-if="loaded" class="app-content">
			<transition name="screen" mode="out-in">
				<home v-if="app.screen == 'home'" />
				<game v-if="app.screen == 'game'" />
			</transition>
		</div>

		<div v-if="app.screen != 'game'" class="menu">
			<div class="menu-content">
				<span v-if="app.screen != 'game' || (current.status == 'win' || current.status == 'lose')" class="player-gold">
					{{ app.account.gold }} <span class="icon"></span>
				</span>
				<span class="lang">
					<span :class="{ active: lang == 'en' }" @click="set_lang('en')">EN</span>
					<span :class="{ active: lang == 'fr' }" @click="set_lang('fr')">FR</span>
				</span>
			</div>
		</div>

		<div v-if="!loaded" class="loading">
			<div class="progress-bar">
				<div class="progress" :style="{ width: progress + '%' }"></div>
			</div>
		</div>

		<div v-if="wrong_navigator" class="wrong-navigator">
			<p>{{ l.using_navigator }} {{ browser.name }}.</p>
			<p>{{ l.wrong_navigator }}</p>
		</div>

		<div v-if="height < 720" class="wrong-height" @click="openFullscreen()">
			<p>{{ l.wrong_height }}</p>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Home from '@/components/home.vue'
import Game from '@/components/game.vue'
const { detect } = require('detect-browser');

export default {
	name: 'app',
	data: function() {
		return {
			height: 0,
			browser: detect(),
			loaded: false,
			progress: 0,
		}
	},
	computed: Object.assign(mapGetters([ 'l', 'lang', 'app', 'current' ]), {
		wrong_navigator: function() {
			return (
				this.browser.name != 'firefox' &&
				this.browser.name != 'chrome' &&
				this.browser.name != 'safari' &&
				this.browser.name != 'opera' &&
				this.browser.name != 'vivaldi'
			)
		},
	}),
	methods: {
		init: function() {
			this.$store.dispatch('init_app')
			
			var self = this
			var context = require.context('@/assets', true, /\.(png)$/)
			var files = []

			context.keys().forEach(function(filename) {
				files.push(context(filename))
			})

			var n = files.length
			var loaded = 0
			for (var i in files) {
				var img = new Image()
				img.src = files[i]
				img.onload = function(e) {
					loaded++
					self.progress = loaded * 100 / n
					if (loaded == n) self.loaded = true
				}
			}

			// this.loaded = true
			// var hero = _.find(this.app.account.collection.heroes, { slug: 'headless-knight' })
			// this.$store.dispatch('init_game', { hero: hero })
		},
		set_lang: function(lang) {
			this.$store.dispatch('set_lang', { lang: lang })
		},
		resize: function() {
			this.height = window.innerHeight
		},
		openFullscreen: function() {
			var elem = document.documentElement
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.mozRequestFullScreen) { /* Firefox */
				elem.mozRequestFullScreen();
			} else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) { /* IE/Edge */
				elem.msRequestFullscreen();
			}
		}
	},
	mounted: function() {
		this.resize()
		this.init()
		window.onresize = this.resize
	},
	components: { Home, Game }
}
</script>
<style lang="stylus">
@import './assets/css/app'
@import './assets/css/scrollbar'

@font-face
	font-family Zepto-Regular
	font-style normal
	src url(./assets/fonts/Zepto-Regular.ttf)

@font-face
	font-family PearSoda
	font-style normal
	src url(./assets/fonts/PearSoda.ttf)
	
*
	margin 0
	padding 0
	position relative
	box-sizing border-box
	user-select none
	
img
	pointer-events none

:root
	font-size 62.5%
	
html, body, #app
	height 100%
	overflow hidden
	
body
	font-family 'Zepto-Regular', sans-serif
	font-size 1.6rem
	line-height 1.25em
	font-weight 500
	color light
	background-color dark
	image-rendering pixelated
	cursor default
	&:active
		cursor grab


#app
	width 100%
	.app-content
		display block
		height 100%
		// max-width 920px
		// margin 0 auto
		.screen
			display block
			height 100%
			width 100%
			transition 0.5s easeOutQuart
			&.screen-enter, &.screen-leave-to
				opacity 0
	.menu
		position absolute
		left 0
		right 0
		top 0
		background darken(dark, 10%)
		height 40px
		line-height @height
		.menu-content
			height 100%
			max-width 920px
			margin 0 auto
			.player-gold
				.icon
					display inline-block
					width 16px
					height 16px
					top 3px
					margin 0 0 0 4px
					background url(./assets/img/ui/icons.png) 0 0 no-repeat
					background-position (-16px * 3) 0
					background-size auto 32px
			.lang
				position absolute
				right 0
				top 0
				span
					display inline-block
					padding 0 12px
					height @height
					opacity 0.5
					cursor pointer
					&:first-child
						padding-right 4px
					&:last-child
						padding-left 4px
					&:hover
						opacity 0.75
					&.active
						opacity 1
	.loading
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background dark
		.progress-bar
			position absolute
			left 50%
			top 50%
			width 200px
			height 4px
			margin (-@height / 2) 0 0 (-@width / 2)
			background-color darken(dark, 25%)
			.progress
				position absolute
				left 0
				top 0
				height 100%
				width 0
				background-color light
	.wrong-navigator
		position fixed
		top 24px
		left 50%
		width 450px
		margin-left (-@width / 2)
		padding 16px 24px
		text-align center
		color light
		background-color red
	.wrong-height
		position fixed
		top 64px
		left 24px
		width 250px
		padding 16px 24px
		text-align left
		color light
		background-color darken(dark, 25%)
	
.box
	display block
	width 100%
	padding 4px 0
	.box-title
		position absolute
		left 0
		top -28px
		line-height 24px

.scroll-wrap
	.scroll
		display flex !important
		flex-direction column !important
		.scroll-content
			display block
			overflowX hidden
			overflowY scroll
			flex 0 1 auto
		
@media screen and (max-width: 330px)
	#app .menu
		display none
		

</style>
